// extracted by mini-css-extract-plugin
export default {"editIcon":"Monthly_editIcon__LiZy3","monthlyTable":"Monthly_monthlyTable__CdWZ4"};